import './index.css'
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { faSync } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import api from 'api'

import actionTypes from 'store/actions'

import SectionTitle from 'components/Common/SectionTitle'
import DaySpan from 'components/Common/DaySpan'
import AlertBadge from 'components/Common/AlertBadge'

import CashflowTab from './components/CashflowTab'
import BalanceTab from './components/BalanceTab'
import PayableTab from './components/PayableTab'
import ReceivableTab from './components/ReceivableTab'
import CloseIcon from '@mui/icons-material/Close'
import { ButtonBase } from '@mui/material'

const items = [
  {
    disabled: false,
    title: 'Cashflow',
    content: <CashflowTab />,
  },
  {
    disabled: false,
    title: 'Balance',
    content: <BalanceTab />,
  },
  {
    disabled: false,
    title: 'Payables',
    content: <PayableTab />,
  },
  {
    disabled: false,
    title: 'Receivables',
    content: <ReceivableTab />,
  },
]

function FinancialOverviewDialog() {
  const [selected, setSelected] = React.useState(0)

  const dispatch = useDispatch()
  const codatConnected = useSelector(state => state.appReducer.accountCodatConnected)
  const daySpanSelected = useSelector(state => state.appReducer.financialOverviewDaySpan)
  const companyId = useSelector(state => state.apiResponseReducers.companyId)
  const [onRefresh, setOnRefresh] = useState(null)

  const financialOverviewsApi = async () => {
    if (codatConnected) {
      await api.getPayablesChartData(companyId, daySpanSelected)
      await api.getReceivablesChartData(companyId, daySpanSelected)
    }
  }

  useEffect(() => {
    financialOverviewsApi().then()
    // eslint-disable-next-line
  }, [daySpanSelected, onRefresh])

  const handleSelect = e => {
    setSelected(e.selected)
  }

  const onDaySpanClicked = days => {
    dispatch({ type: actionTypes.SETFINANCIALOVERVIEWDAYSPAN, data: days })
  }

  return (
    <div className="d-flex flex-column h-100 k-relative" style={{ color: '#25245f' }}>
      <div>
        <div className="row">
          <div className="col-md-6 d-flex justify-content-start">
            <div className="bg-transparent border-light p-3">
              <SectionTitle title="Financial Overview" />
              <span className="k-mx-2 k-cursor-pointer" onClick={() => codatConnected && setOnRefresh(true)}>
                <FontAwesomeIcon icon={faSync} color="LightGray" />
              </span>
            </div>
          </div>
          <div className="col-md-6 d-flex justify-content-end">
            <CloseIcon
              onClick={() => {
                dispatch({ type: actionTypes.HIDEDIALOG })
              }}
              fontSize="medium"
              sx={{
                cursor: 'pointer',
                position: 'absolute',
                top: '10px',
                right: '10px',
              }}
            />
          </div>
        </div>
      </div>
      <div className="k-d-flex k-justify-content-end">
        <DaySpan onClick={onDaySpanClicked} daySpanSelected={daySpanSelected} style={{ positon: 'absolute' }} />
      </div>
      {onRefresh && <AlertBadge top="30px" onClose={() => setOnRefresh(false)} />}
      <TabStrip selected={selected} onSelect={handleSelect} className="fo-dialog-tab flex-grow-1" animation={false}>
        {items.map((item, index) => {
          return (
            <TabStripTab disabled={item.disabled} title={<ButtonBase>{item.title}</ButtonBase>} key={index} contentClassName="tab-full-height">
              {item.content}
            </TabStripTab>
          )
        })}
      </TabStrip>
    </div>
  )
}

export default FinancialOverviewDialog
